// extracted by mini-css-extract-plugin
module.exports = {"select_share":"select_share-2Q4zcawJ","header":"header-BHRhYkAO"};